/* eslint-disable @next/next/no-html-link-for-pages */
import { withTranslation } from "next-i18next";
import { Link, Image } from "@components/core";
import { useRouter } from "next/compat/router";
import classNames from "classnames";

const LeClosetLinks = ({ t }) => {
  const router = useRouter();

  return (
    <div className="d-flex flex-column flex-sm-row mb-4 mb-sm-0 footer justify-content-between">
      <section className="d-flex flex-column w-50 mt-4">
        <h5 className="mb-4 w-50 d-none d-sm-block d-md-none-sm-none"><Image src="logo" alt="logo" /></h5>
      </section>
      <div className="footer-section-container mb-md-0 mt-4">
        <section className="footer-section">
          <h5 className="mb-4">{t("common:footer.help")}</h5>
          <Link
            href={t("common:footer.links.help_center.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("common:footer.links.help_center.text")}
          </Link>
          <Link
            href={t("common:footer.links.contact_us.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("common:footer.links.contact_us.text")}
          </Link>

          <h5 className="my-4">{t("common:footer.services")}</h5>
          <Link
            href={t("common:footer.links.catalog.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("common:footer.links.catalog.text")}
          </Link>

          <Link
            href={t("common:footer.links.gift_cards.link")}
            className="link-dark footer-link"
            noUnderline
          >
            {t("common:footer.links.gift_cards.text")}
          </Link>

          <a
            href={t("common:footer.links.how_it_works.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.how_it_works.text")}
          </a>

        </section>

        <section className="footer-section">
          <h5 className="mb-4">{t("common:footer.about")}</h5>
          <a
            href={t("common:footer.links.our_brands.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.our_brands.text")}
          </a>
          <a
            href={t("common:footer.links.reviews.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.reviews.text")}
          </a>
          <a
            href={t("common:footer.links.our_vision.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.our_vision.text")}
          </a>
          <a
            href={t("common:footer.links.sustainable_fashion.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.sustainable_fashion.text")}
          </a>
          <a
            href={t("common:footer.links.press.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.press.text")}
          </a>
          <a
            href={t("common:footer.links.morphology.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.morphology.text")}
          </a>
          <a
            href={t("common:footer.links.maternity_clothes_rental.link")}
            className="link-dark footer-link no-underline"
          >
            {t("common:footer.links.maternity_clothes_rental.text")}
          </a>
        </section>
      </div>
      <section className="d-flex flex-sm-column footer-social-section mt-4 w-50">
        <div className="mb-sm-4 footer-social-section-block">
          <h5 className="mb-4">{t("common:footer.network")}</h5>
          <div className="d-flex">
            <a
              href="https://www.facebook.com/lecloset.fr?fref=ts"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image src="facebookFooter" alt="logo facebook" className="footer-social-section-logo" />
            </a>

            <a
              href="https://www.pinterest.fr/Le_Closet"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image src="pinterest" alt="logo pinterest" className="footer-social-section-logo" />
            </a>

            <a
              href="https://www.instagram.com/leclosetfr"
              className="link-dark no-underline me-4"
              target="_blank"
              rel="noreferrer"
            >
              <Image src="instagram" alt="logo instagram" className="footer-social-section-logo" />
            </a>
          </div>
        </div>
        <div className={classNames("footer-social-section-block", router?.locale === router?.defaultLocale ? "d-flex" : "d-none")}>
          <div className="footer-social-section-smartphone-logo me-2">
            <Image src="smartphone" alt="smartphone" />
          </div>
          <div className="footer-social-section-smartphone-links">
            <h5 className="h6 mb-0">{t("common:footer.app_available")}</h5>
            <h5 className="h6 mb-0">
              <a
                href="https://apps.apple.com/fr/app/le-closet/id1442294906"
                className="link-dark no-underline"
                target="_blank"
                rel="noreferrer"
              >
                {t("common:footer.ios")}
              </a>
              /
              <a
                href="https://play.google.com/store/apps/details?id=com.lecloset"
                className="link-dark no-underline"
                target="_blank"
                rel="noreferrer"
              >
                {t("common:footer.android")}
              </a>
            </h5>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withTranslation("common")(LeClosetLinks);
